import { render, staticRenderFns } from "./KeyMetrics.vue?vue&type=template&id=0daae970"
import script from "./KeyMetrics.vue?vue&type=script&lang=js"
export * from "./KeyMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports